import React from "react";
import { observer } from "mobx-react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Trans } from "react-i18next";
import moment from "moment";
import classnames from "classnames";
import { Tooltip } from "antd";
import { useStore } from "../../../../store/rootStore";
import TemplateTitle from "../TemplateTitle/TemplateTitle";
import AdvancedSettings from "../../../Chat/PreparedMessages/TemplateMessages/components/AddOrEditTemplate/AdvancedSettings";
import { CHAT_STATUS } from "@whatsper/texterchat-common";
import useCheckIfMobile from "../../../../helpers/hooks/useCheckIfMobile";
import { DESKTOP_WIDTH } from "../../../../constants";
import { getDirection } from "../../../../helpers";
import s from "./SecondPage.module.scss";
const SecondPage = () => {
    var _a;
    const { wizardStore, templateMessagesStore } = useStore();
    const isLessThanDesktop = useCheckIfMobile(DESKTOP_WIDTH);
    const assignedTo = templateMessagesStore.templateChatStatus === CHAT_STATUS.ASSIGNED;
    const showEllipsis = assignedTo && isLessThanDesktop;
    const durationSeconds = templateMessagesStore.templateReplyActionDuration;
    const explanationValues = () => {
        const date = moment().add(durationSeconds, "seconds");
        return {
            hours: Math.round(durationSeconds / 3600),
            date: `${date.format("D/MM/YYYY")}`,
            time: `${date.format("HH:mm")}`,
        };
    };
    return (React.createElement("div", { className: classnames(s.secondPageWrapper, {
            [s.rtl]: getDirection() === 'rtl',
        }) },
        React.createElement(TemplateTitle, { title: ((_a = wizardStore.chosenTemplate) === null || _a === void 0 ? void 0 : _a.title) || '', isRtl: getDirection() === 'rtl' }),
        React.createElement("div", { className: classnames(s.csvWizardAdvancedDescriptionBlock, {
                [s.rtl]: getDirection() === 'rtl',
            }) },
            React.createElement(ExclamationCircleOutlined, { className: s['wizard-info-circle'] }),
            React.createElement(Tooltip, { title: showEllipsis ? (React.createElement(Trans, { i18nKey: "templateAdvancedSettingsExplanationP2", values: explanationValues() })) : undefined },
                React.createElement("p", { className: classnames(s.bulkWizard, {
                        [s.ellipsis]: showEllipsis,
                    }) },
                    React.createElement(Trans, { i18nKey: "templateAdvancedSettingsExplanationP2", values: explanationValues() })))),
        React.createElement("div", { className: s.bulkAdvandesSettingsWrapper },
            React.createElement(AdvancedSettings, { canAttachFile: true, canChangeMode: false }))));
};
export default observer(SecondPage);
